(function (ng) {
    // Declaring services / controllers
    // This creates the modules, which can then be resolved / extended in other files
    ng.module('evo.Compare.Services', []);
    ng.module('evo.Compare.Directives', []);
    ng.module('evo.Compare.Filters', []);
    ng.module('evo.Compare.Controllers', []);
    ng.module('evo.Shared.Filters', []);
    ng.module('evo.Compare.App', ['evo.Compare.Controllers', 'evo.Compare.Directives', 'evo.Compare.Filters', 'evo.Compare.Services', 'ngAnimate', 'evo.Shared.Filters']);
})(angular);